import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import VehicleOwner from "./VehicleOwner";
import Vehicles from "./Vehicles";
import VehicleImage from "./VehicleImage";
import VehicleDocument from "./VehicleDocument";
import VehicleInfoExtra from "./VehicleInfoExtra";
import {
  getCountryAllist,
  getVehicleProcessDetails,
} from "../../services/VehicleService";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useLocation, useParams } from "react-router-dom";
import { geCertificateDetails } from "../../services/CertificateServices";
import { useTranslation } from "react-i18next";
import VehicleVideo from "./VehicleVideo";
import VehiclePartMangement from "./VehiclePartMangement";
import PartsCheck from "./PartsCheck";
import VehicleDepreciation from "./VehicleDepreciation";
import VehiclePartCheckList from "./VehiclePartCheckList";
import VehicleModelByVIN from "./VehicleModelByVIN";

const Vehicle = () => {
  const [activeTab, setActiveTab] = useState("vehicle");
  const [vehicleProcessList, setVehicleProcessList] = useState("");
  const [AllvehicleSerachData, setAllVehicleSerachData] = useState({
    vin: "",
    plate: "",
    country: "",
    serach_vehicle_id: 1,
  });
  const [vehicleVinData, setVehicleVinData] = useState({});
  const [vehicleVinTecData, setVehicleVinTecData] = useState({});
  const [vehiclePlateData, setVehiclePlateData] = useState({});
  const [countryAllData, setCountryAllData] = useState([]);
  const [certificateDetails, SetCertificateDetails] = useState({});
  let ownerId = localStorage.getItem("ownerList");
  let vehicleId;
  vehicleId = localStorage.getItem("vehicleId");

  const { t } = useTranslation();

  const state = useLocation();
  const { uuid } = useParams();

  const toggleTab = (tab) => {
    let isvalid = false;
    let storedVehicleId = vehicleId || state?.state?.id;

    if (storedVehicleId) {
      isvalid = true;
      localStorage.setItem("vehicleId", storedVehicleId);
    }

    if (isvalid) {
      if (activeTab !== tab) setActiveTab(tab);
    }
  };

  useEffect(() => {
    if (state?.state?.id) {
      vehicleId = localStorage.setItem("vehicleId", state?.state?.id);
    }
  }, [state?.state]);

  useEffect(() => {
    if (state?.state?.certificate_id) {
      let data = {
        certificate_id: state.state.certificate_id,
      };

      geCertificateDetails(data)
        .then((response) => {
          SetCertificateDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [state.state?.certificate_id]);
  // useEffect(() => {
  //   if (vehicleId) {
  //     let data = {
  //       vehicle_id: vehicleId ? vehicleId : "",
  //       data_type: activeTab,
  //       owner_id: ownerId,
  //     };

  //     getVehicleProcessDetails(data)
  //       .then((response) => {
  //         setVehicleProcessList(response.data.data);
  //       })
  //       .catch((err) => {});
  //   }
  // }, [activeTab]);
  // useEffect(() => {
  //   if (state?.state) {
  //     let data = {
  //       vehicle_id: state?.state?.id,
  //       data_type: activeTab,
  //       owner_id: state?.state?.vehicle_owner_id,
  //     };

  //     getVehicleProcessDetails(data)
  //       .then((response) => {
  //         setVehicleProcessList(response.data.data);
  //       })
  //       .catch((err) => {});
  //   }
  // }, [activeTab, state]);

  // useEffect(() => {
  //   if (uuid) {
  //     let data = {
  //       vehicle_id: uuid,
  //       data_type: activeTab,
  //       owner_id: ownerId,
  //     };

  //     getVehicleProcessDetails(data)
  //       .then((response) => {
  //         setVehicleProcessList(response.data.data);

  //         vehicleId = localStorage.setItem("vehicleId", uuid);
  //       })
  //       .catch((err) => {});
  //   }
  // }, [activeTab, uuid]);

  useEffect(() => {
    const id = uuid || vehicleId || state?.state?.id;
    const owner = state?.state?.vehicle_owner_id || ownerId;

    if (!id) return;

    const data = {
      vehicle_id: id,
      data_type: activeTab,
      owner_id: owner,
    };

    setVehicleProcessList([]);

    getVehicleProcessDetails(data)
      .then((response) => {
        setVehicleProcessList(response.data.data);

        const vehicleData = response.data.data;
        if (vehicleData?.id) {
          localStorage.setItem("vehicleId", vehicleData.id);
        }
      })
      .catch((err) => {
        console.error("Error fetching vehicle process details:", err);
      });
  }, [activeTab, uuid, vehicleId, state]);

  useEffect(function () {
    getCountryAllist()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].country,
          });
        }
        setCountryAllData(list);
      })
      .catch((err) => {});
  }, []);

  // Só habilitamos as pills quando a viatura já foi guardada
  const toolsEnabled = Boolean(vehicleId || state?.state?.id);

  // Métricas preview — só renderizam se os dados existirem no vehicleProcessList
  const partsCount =
    vehicleProcessList?.part_count ??
    vehicleProcessList?.total_parts ??
    vehicleProcessList?.parts_count;
  const virtualPartsCount =
    vehicleProcessList?.virtual_parts_count ??
    vehicleProcessList?.reference_parts_count;
  const depreciationValue =
    vehicleProcessList?.depreciation_value ??
    vehicleProcessList?.vehicle_value;
  const checklistOk =
    vehicleProcessList?.check_list_ok ?? vehicleProcessList?.checklist_ok;
  const checklistTotal =
    vehicleProcessList?.check_list_total ??
    vehicleProcessList?.checklist_total;

  const toolPills = [
    {
      tab: "vehicle_part_mangement",
      icon: "bi-gear",
      labelKey: "tab_vehicle_parts",
      metric:
        partsCount !== undefined && partsCount !== null
          ? `${partsCount} ${t("tab_vehicle_parts_metric_suffix", {
              defaultValue: "peças",
            })}`
          : null,
    },
    {
      tab: "vehicle_part_check",
      icon: "bi-boxes",
      labelKey: "tab_virtual_parts",
      metric:
        virtualPartsCount !== undefined && virtualPartsCount !== null
          ? `${virtualPartsCount} ${t("tab_virtual_parts_metric_suffix", {
              defaultValue: "refs",
            })}`
          : null,
    },
    {
      tab: "depreciation",
      icon: "bi-graph-down",
      labelKey: "depreciation",
      metric:
        depreciationValue !== undefined && depreciationValue !== null
          ? `€ ${depreciationValue}`
          : null,
    },
    {
      tab: "vehicle_part_check_list",
      icon: "bi-card-checklist",
      labelKey: "vehicle_check_list",
      metric:
        checklistOk !== undefined &&
        checklistOk !== null &&
        checklistTotal !== undefined &&
        checklistTotal !== null
          ? `${checklistOk}/${checklistTotal} OK`
          : null,
    },
    {
      tab: "vehicle_model_by_vin",
      icon: "bi-search",
      labelKey: "tab_oem_refs",
      metric: null,
    },
  ];

  return (
    <div>
      <section className="content-header content-header-vehcial">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6"></div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          {/* Aviso quando a viatura vem de um certificado e ainda não foi totalmente gravada */}
          {state?.state?.certificate_id && !(vehicleId || state?.state?.id) && (
            <div className="vehicle-cert-warning" role="alert">
              <div className="vehicle-cert-warning-icon">⚠</div>
              <div className="vehicle-cert-warning-body">
                <strong>{t("cert_warning_title")}</strong>
                <span>{t("cert_warning_body")}</span>
              </div>
            </div>
          )}
          <div className="vehicle-taps-content">
            {/* Grupo: Dados Viatura (6 passos) */}
            <div className="vehicle-tab-group-label">{t("tab_group_form")}</div>
            <Nav
              tabs
              className="navPills steps-horizontal-tabs"
              style={{ cursor: "pointer" }}
            >
              <NavItem
                className={`vehicle-m-l ${activeTab ? "vehicle-b" : ""}`}
              >
                <NavLink
                  className={activeTab === "vehicle" ? "active" : ""}
                  onClick={() => toggleTab("vehicle")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-car-front-fill me-1"></i>
                  {t("vehicle")}
                </NavLink>
              </NavItem>

              <NavItem className="vehicle-m-l vehicle-b">
                <NavLink
                  className={activeTab === "vehicle_images" ? "active" : ""}
                  onClick={() => toggleTab("vehicle_images")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-images me-1"></i> {t("images")}
                </NavLink>
              </NavItem>

              <NavItem className="vehicle-m-l vehicle-b">
                <NavLink
                  className={activeTab === "vehicle_video" ? "active" : ""}
                  onClick={() => toggleTab("vehicle_video")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-camera-reels me-2"></i> {t("video")}
                </NavLink>
              </NavItem>
              <NavItem className="vehicle-m-l vehicle-b">
                <NavLink
                  className={activeTab === "vehicle_extra_info" ? "active" : ""}
                  onClick={() => toggleTab("vehicle_extra_info")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-info-lg">{t("extra_info")}</i>
                </NavLink>
              </NavItem>
              <NavItem className="vehicle-m-l vehicle-b">
                <NavLink
                  className={activeTab === "vehicle_owner" ? "active" : ""}
                  onClick={() => toggleTab("vehicle_owner")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-person me-1"></i> {t("owner")}
                </NavLink>
              </NavItem>

              <NavItem className="vehicle-m-l vehicle-b">
                <NavLink
                  className={activeTab === "vehicle_documents" ? "active" : ""}
                  onClick={() => toggleTab("vehicle_documents")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-file-earmark-medical me-1"></i>{" "}
                  {t("document")}
                </NavLink>
              </NavItem>
            </Nav>

            {/* Layout: main content + sticky tools sidebar to the right */}
            <div className="veh-page-grid">
              <div className="veh-page-main">
                <TabContent activeTab={activeTab}>
              <TabPane tabId="vehicle">
                <Vehicles
                  setActiveTab={setActiveTab}
                  vehicleProcessList={vehicleProcessList}
                  setVehicleVinData={setVehicleVinData}
                  vehicleVinData={vehicleVinData}
                  vehicleVinTecDat={vehicleVinTecData}
                  setVehicleVinTecData={setVehicleVinTecData}
                  vehiclePlateData={vehiclePlateData}
                  setVehiclePlateData={setVehiclePlateData}
                  countryAllData={countryAllData}
                  AllvehicleSerachData={AllvehicleSerachData}
                  setAllVehicleSerachData={setAllVehicleSerachData}
                  certificateDetails={certificateDetails}
                />
              </TabPane>

              <TabPane tabId="vehicle_images">
                <VehicleImage
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                  vehicleProcessList={vehicleProcessList}
                  certificateDetails={certificateDetails}
                />
              </TabPane>

              <TabPane tabId="vehicle_video">
                <VehicleVideo
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                  vehicleProcessList={vehicleProcessList}
                  certificateDetails={certificateDetails}
                />
              </TabPane>
              <TabPane tabId="vehicle_extra_info">
                <VehicleInfoExtra
                  setActiveTab={setActiveTab}
                  vehicleProcessList={vehicleProcessList}
                  activeTab={activeTab}
                  vehicleVinData={vehicleVinData}
                  vehiclePlateData={vehiclePlateData}
                  certificateDetails={certificateDetails}
                />
              </TabPane>
              <TabPane tabId="vehicle_owner">
                <VehicleOwner
                  setActiveTab={setActiveTab}
                  vehicleProcessList={vehicleProcessList}
                  certificateDetails={certificateDetails}
                />
              </TabPane>

              <TabPane tabId="vehicle_documents">
                <VehicleDocument
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  vehicleProcessList={vehicleProcessList}
                  certificateDetails={certificateDetails}
                />
              </TabPane>
              {(vehicleId || state?.state?.id) && (
                <TabPane tabId="vehicle_part_mangement">
                  <VehiclePartMangement
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    vehicleProcessList={vehicleProcessList}
                    certificateDetails={certificateDetails}
                    vehicleId={vehicleId || state?.state?.id}
                  />
                </TabPane>
              )}

              {(vehicleId || state?.state?.id) && (
                <TabPane tabId="vehicle_part_check">
                  <PartsCheck
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    vehicleProcessList={vehicleProcessList}
                    certificateDetails={certificateDetails}
                    vehicleId={vehicleId || state?.state?.id}
                  />
                </TabPane>
              )}

              <TabPane tabId="depreciation">
                <VehicleDepreciation
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  vehicleProcessList={vehicleProcessList}
                  certificateDetails={certificateDetails}
                />
              </TabPane>

              {(vehicleId || state?.state?.id) && (
                <TabPane tabId="vehicle_part_check_list">
                  <VehiclePartCheckList
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    vehicleProcessList={vehicleProcessList}
                    certificateDetails={certificateDetails}
                    vehicleId={vehicleId || state?.state?.id}
                  />
                </TabPane>
              )}

              {(vehicleId || state?.state?.id) && (
                <TabPane tabId="vehicle_model_by_vin">
                  <VehicleModelByVIN
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    vehicleProcessList={vehicleProcessList}
                    certificateDetails={certificateDetails}
                    vehicleId={vehicleId || state?.state?.id}
                    setVehicleProcessList={setVehicleProcessList}
                  />
                </TabPane>
              )}
                </TabContent>
              </div>

              {/* Sidebar Pills fixa à direita (Funcionalidades) */}
              <aside
                className="veh-tools-sidebar"
                aria-label={t("tab_group_tools")}
              >
                {toolPills.map((pill) => {
                  const isActive = activeTab === pill.tab;
                  const handleClick = () => {
                    if (!toolsEnabled) return;
                    toggleTab(pill.tab);
                  };
                  return (
                    <button
                      key={pill.tab}
                      type="button"
                      className={`veh-tool-pill ${isActive ? "active" : ""}`}
                      onClick={handleClick}
                      disabled={!toolsEnabled}
                      aria-pressed={isActive}
                      style={
                        !toolsEnabled
                          ? { opacity: 0.5, cursor: "not-allowed" }
                          : undefined
                      }
                    >
                      <i
                        className={`bi ${pill.icon} veh-tool-pill-icon`}
                        aria-hidden="true"
                      ></i>
                      <p className="veh-tool-pill-label">{t(pill.labelKey)}</p>
                      {pill.metric ? (
                        <div className="veh-tool-pill-metric">{pill.metric}</div>
                      ) : null}
                    </button>
                  );
                })}
              </aside>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Vehicle;
